import { motion } from 'framer-motion'

interface NumberGridProps {
  numbers: string[]
  className?: string
  onNumberClick?: (number: string) => void
}

export const NumberGrid = ({ numbers, className = '', onNumberClick }: NumberGridProps) => {
  if (!numbers || numbers.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400">
        暂无可用号码
      </div>
    )
  }

  return (
    <div className={`grid grid-cols-2 md:grid-cols-4 gap-4 ${className}`}>
      {numbers.map((num) => (
        <motion.div
          key={num}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="text-2xl font-bold text-center py-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg text-white hover:opacity-90 transition-opacity cursor-pointer"
          onClick={() => onNumberClick?.(num)}
        >
          {num}
        </motion.div>
      ))}
    </div>
  )
}